import { useCheckIsEmerson } from "@shared/hooks/useCheckIsEmerson/useCheckIsEmerson";
import { isProduction, isE2E } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const AdaJS = () => {
  const isEmerson = useCheckIsEmerson();

  if (isE2E()) return null;

  const adaSettings = {
    crossWindowPersistence: true,
    hideMask: false,
    testMode: !isProduction(),
  };

  const handle = isEmerson ? "emersonecologics" : "fullscript";

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          /* eslint-disable-next-line @typescript-eslint/naming-convention */
          __html: `window.adaSettings=${JSON.stringify(adaSettings).replace(/</g, "\\u003c")};`,
        }}
      ></script>
      <script
        id="__ada"
        data-handle={handle}
        data-testid="ada"
        src="https://static.ada.support/embed2.js"
        suppressHydrationWarning
      ></script>
    </>
  );
};

export { AdaJS };
